import clsx from 'clsx'

const BASE_STEPS = ['parsing', 'chunking', 'embedding', 'storing'] as const
const WITH_ENRICH_STEPS = ['parsing', 'chunking', 'enriching', 'embedding', 'storing'] as const

const LABELS: Record<string, string> = {
  parsing: 'parse',
  chunking: 'chunk',
  enriching: 'enrich',
  embedding: 'embed',
  storing: 'store',
}

interface IndexingStepLineProps {
  phase: string
  includeEnrich: boolean
  className?: string
}

export default function IndexingStepLine({
  phase,
  includeEnrich,
  className,
}: IndexingStepLineProps) {
  const steps: readonly string[] = includeEnrich ? WITH_ENRICH_STEPS : BASE_STEPS
  let currentIdx = steps.indexOf(phase)
  if (currentIdx < 0) {
    // Unknown/queued → treat as first step in progress
    currentIdx = 0
  }

  return (
    <span
      className={clsx(
        'inline-flex items-center flex-wrap gap-x-1 text-xs font-medium text-blue-300/90',
        className
      )}
      aria-label={`Indexing: ${LABELS[steps[currentIdx]!] ?? phase}`}
    >
      {steps.map((step, i) => {
        const label = LABELS[step] ?? step
        const done = i < currentIdx
        const current = i === currentIdx
        return (
          <span key={step} className="inline-flex items-center gap-x-1">
            {i > 0 && <span className="text-blue-500/50">·</span>}
            <span
              className={clsx(
                current && 'text-blue-200',
                done && 'text-emerald-400/90',
                !done && !current && 'text-harbor-text-muted'
              )}
            >
              {label}
              {done ? ' ✓' : current ? ' …' : ''}
              {current && (
                <span className="ml-1 inline-block w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse align-middle" />
              )}
            </span>
          </span>
        )
      })}
    </span>
  )
}
